import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { useContext, useEffect, useState, useMemo } from "react";
import { FornecedorContext } from "../contexts/FornecedorContext";
import { FormControlLabel } from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";

export default function ModalFornecedorBanco({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    //Dados Gerais

    bank,
    setBank,
    listBank,
    geralErrors,
    setGeralErrors,
  } = useContext(FornecedorContext);

  const [banco, setBanco] = useState("");
  const [agencia, setAgencia] = useState("");
  const [agenciaDigito, setAgenciaDigito] = useState("");
  const [conta, setConta] = useState("");
  const [contaDigito, setContaDigito] = useState("");
  const [tipoPix, setTipoPix] = useState("");
  const [chavePix, setChavePix] = useState("");
  const [contaPrincipal, setContaPrincipal] = useState(false);

  const listOptionsPix = useMemo(
    () => [
      {
        label: "CPF/CNPJ",
        id: "CPF/CNPJ",
      },
      {
        label: "Telefone",
        id: "Telefone",
      },
      {
        label: "Email",
        id: "Email",
      },
      {
        label: "Outros",
        id: "Outros",
      },
    ],
    []
  );

  useEffect(() => {
    if (!rowEdit) {
      setBanco(null);
      setAgencia("");
      setAgenciaDigito("");
      setContaDigito("");
      setConta("");
      setTipoPix("");
      setChavePix(null);
      setContaPrincipal(false);
      return;
    }

    setBanco(listBank.find((opt) => opt.codigo === rowEdit.codigo_banco));
    setAgencia(rowEdit.agencia);
    setAgenciaDigito(rowEdit.agencia_digito);
    setConta(rowEdit.conta);
    setContaDigito(rowEdit.conta_digito);
    setTipoPix(
      listOptionsPix.find((opt) => opt.id === rowEdit.tipo_pix) || null
    );
    setChavePix(rowEdit.chave_pix);
    setContaPrincipal(rowEdit.conta_padrao ? true : false);
  }, [rowEdit, listOptionsPix, listBank]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const required = [
      { value: banco, key: "banco" },
      { value: agencia, key: "agencia" },
      { value: agenciaDigito, key: "agenciaDigito" },
      { value: conta, key: "conta" },
      { value: contaDigito, key: "contaDigito" },
    ];

    let resultValidation = validNotNull(required);
    if (resultValidation.error) {
      setGeralErrors(resultValidation.errorsValidation);
      return notify("Verifique se os campos obrigatórios estão preenchidos.");
    }

    const body = {
      id: uuidv4(),
      codigo_banco: banco?.codigo,
      agencia: agencia,
      agencia_digito: agenciaDigito,
      conta: conta,
      conta_digito: contaDigito,
      tipo_pix: tipoPix ? tipoPix.id : null,
      chave_pix: chavePix,
      conta_padrao: contaPrincipal,
    };
    let newArrayBank = [];
    const index = bank.findIndex((account) => account.id === rowEdit?.id);
    if (rowEdit && rowEdit?.id) {
      // EDIÇÃO  DE CONTA
      body.id = rowEdit.id;

      if (rowEdit[index] !== -1) {
        const copy = [...bank];
        copy[index] = body;
        newArrayBank = copy;
      }
    } else {
      // // INCLUSÃO DE CONTA
      if (!bank.length) {
        body.conta_padrao = true;
      }
      newArrayBank = [...bank, body];
    }

    if (contaPrincipal && bank.length > 1) {
      let idPrincipal = rowEdit ? index : bank.length;
      const newList = newArrayBank.map((element, index) => {
        if ((index || index === 0) && index === idPrincipal) {
          return element;
        } else {
          return {
            ...element,
            conta_padrao: false,
          };
        }
      });
      newArrayBank = newList;
    }

    setBank(newArrayBank);

    setBanco(null);
    setAgencia("");
    setAgenciaDigito("");
    setContaDigito("");
    setConta("");
    setTipoPix(null);
    setChavePix("");
    setContaPrincipal(false);
    setOpen(false);
    setRowEdit(null);
    setGeralErrors(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {rowEdit && rowEdit.id
          ? `Editar informação financeira`
          : "Cadastrar informação financeira"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} justifyContent="flex-start">
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <SelectErp
              id="banco"
              label="Banco*"
              optionsList={listBank}
              value={banco}
              setValue={setBanco}
              descriptionField="nome"
              helperText={geralErrors.banco || ""}
              error={geralErrors.banco ? true : false}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="agencia"
              label="Agência*"
              value={agencia}
              setValue={setAgencia}
              helperText={geralErrors.agencia || ""}
              error={geralErrors.agencia ? true : false}
            />
          </Grid>
          <Grid item lg={4} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="agenciaDigito"
              label="Dígito da Agência*"
              value={agenciaDigito}
              setValue={setAgenciaDigito}
              helperText={geralErrors.agenciaDigito || ""}
              error={geralErrors.agenciaDigito ? true : false}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="conta"
              label="Conta*"
              value={conta}
              setValue={setConta}
              helperText={geralErrors.conta || ""}
              error={geralErrors.conta ? true : false}
            />
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="contaDigito"
              label="Dígito da Conta*"
              value={contaDigito}
              setValue={setContaDigito}
              helperText={geralErrors.contaDigito || ""}
              error={geralErrors.contaDigito ? true : false}
            />
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <SelectErp
              id="tipoPix"
              label="Tipo Chave Pix"
              optionsList={listOptionsPix}
              value={tipoPix}
              setValue={setTipoPix}
              descriptionField="label"
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <TextFieldErp
              id="chavePix"
              label="Chave Pix"
              value={chavePix}
              setValue={setChavePix}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={contaPrincipal}
                  onChange={() => setContaPrincipal((current) => !current)}
                  color="primary"
                />
              }
              label="Conta Principal"
              labelPlacement="end"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
        <Btn label="Salvar" onClick={handleAdd} />
      </DialogActions>
    </Dialog>
  );
}
